
import { Button } from "@/components/ui/button";
import { LogIn } from "lucide-react";
import { CGVDialog } from "./CGVDialog";

interface OrderActionsProps {
  isSubmitting: boolean;
  showConfirmation: boolean;
  user: any;
  isCartEmpty: boolean;
  total: number;
  onInitiateOrder: () => void;
  onConfirmOrder: () => void;
  onCancelOrder: () => void;
  onLogin: () => void;
}

export const OrderActions = ({
  isSubmitting,
  showConfirmation,
  user,
  isCartEmpty,
  total,
  onInitiateOrder,
  onConfirmOrder,
  onCancelOrder,
  onLogin,
}: OrderActionsProps) => {
  if (user) {
    if (showConfirmation) {
      return (
        <div className="space-y-3 sm:space-y-4 mt-3 sm:mt-6">
          <div className="bg-zinc-50 p-3 sm:p-4 rounded-lg text-xs sm:text-sm border border-zinc-100">
            <p className="font-medium text-zinc-900 mb-1 sm:mb-2">Confirmer votre commande</p>
            <p className="text-[#b82626] font-medium">Total : {total.toFixed(2)} CAD</p>
            <p className="text-zinc-500 mt-1 sm:mt-2 text-xs">
              En confirmant, vous acceptez les {" "}
              <CGVDialog />
              .
            </p>
          </div>
          <div className="grid grid-cols-2 gap-2 sm:gap-3">
            <Button
              variant="outline"
              onClick={onCancelOrder}
              disabled={isSubmitting}
              className="hover:bg-zinc-50 text-xs sm:text-sm h-9 sm:h-10"
            >
              Annuler
            </Button>
            <Button
              onClick={onConfirmOrder}
              disabled={isSubmitting}
              className="bg-[#b82626] hover:bg-[#b82626]/90 text-xs sm:text-sm h-9 sm:h-10"
            >
              {isSubmitting ? "Envoi en cours..." : "Confirmer"}
            </Button>
          </div>
        </div>
      );
    } 
    
    return (
      <Button
        onClick={onInitiateOrder}
        disabled={isSubmitting || isCartEmpty}
        className="w-full mt-3 sm:mt-6 bg-[#b82626] hover:bg-[#b82626]/90 text-xs sm:text-sm h-9 sm:h-10"
        size="lg"
      >
        Passer la commande
      </Button>
    );
  }
  
  return (
    <div className="space-y-2 sm:space-y-3 mt-3 sm:mt-6">
      <Button
        onClick={onLogin}
        className="w-full bg-[#b82626] hover:bg-[#b82626]/90 text-xs sm:text-sm h-9 sm:h-10"
        size="lg"
      >
        <LogIn className="w-3 h-3 sm:w-4 sm:h-4 mr-1 sm:mr-2" />
        Se connecter pour commander
      </Button>
      <p className="text-xs text-zinc-500 text-center">
        Connectez-vous ou créez un compte pour finaliser votre commande
      </p>
    </div>
  );
};
